// Timeline Animation on Scroll
document.addEventListener('DOMContentLoaded', function() {
    const timelineItems = document.querySelectorAll('.timeline-item');
    const observerOptions = {
        threshold: 0.2,
        rootMargin: '0px 0px -100px 0px'
    };
    const observer = new IntersectionObserver(function(entries) {
        entries.forEach((entry)=>{
            if (entry.isIntersecting) entry.target.classList.add('animate');
        });
    }, observerOptions);
    timelineItems.forEach((item)=>{
        observer.observe(item);
    });
});

//# sourceMappingURL=project-portfolio.a251333e.js.map
